//export const Url = "https://mirx.com.ar/panificacion/";
//export const Url = "https://mirx.com.ar/panificacionviamonte2/";
//export const Url = "https://mirx.com.ar/pv/";
export const Url = "https://mirx.com.ar/mac/";
